// FB 17118
import React, { useContext, useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import {
    ModalNextProvider, IconButton, CheckboxField,
} from '@jutro/components';
import { withIntl,IntlContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useAuthentication, AUTH_ERRORS} from 'gw-digital-auth-react';
import metadata from './RIUserList.metadata.json5';
import messages from './RIUserList.messages';
import styles from './RIUserList.module.scss';
import { UserService } from 'gw-capability-ri-policy';

const USER_DELETED = 'userDeleted', CANCEL = 'cancel',  CONFIRM = 'confirm';

const RIUserList = (props) => {
    const { method, isReloading } = props;  
    const { authHeader } = useAuthentication();   

    const intl = useContext(IntlContext);
    
    const goBack =  useCallback(() => {
        method[0]();
    });
    const setMessage = useCallback((messageId) => {
        method[1](messageId);
    });
    const setUser = (user) => {
        method[2](user);
    };
    const initUserLlist = (userList) =>{
        method[3](userList);
    };
    const gotoAddNewUser = () => {
        method[4]();
    };
    const gotoEditUser = (user) => {
        method[5](user);
    };
    const setErrorText = (value) => {
        method[6](value);
    };
    
    const [searchKeyword, setSearchKeyword] = useState('');
    const [riUserList, setRIUserList] = useState([]);
    const [riUserFullList, setRIUserFullList] = useState([]);
    const [isLoading, setLoadingState] = useState(false);    

    useEffect(() => {     
        getUserList();              
    }, []);

    useEffect(() => {     
        
        if(isReloading){
            // After updating the user, it needs to delay little bit waiting for 
            // the server side updating finished then call the service.
            setTimeout(getUserList(), 1000);
        }             
    }, [isReloading]);

    const getUserList = () => {
        
        setLoadingState(true);
        UserService.getRI_UserList( authHeader ).then(
            (response = {}) => {
                if (!_.isUndefined(response)) {                                                           
                    const userList = getRI_UserListTable(response);                    
                    setRIUserList(userList);   
                    setRIUserFullList(userList);
                    initUserLlist(userList); 
                    setLoadingState(false);
                } 
            }).catch((err) => {      
                setLoadingState(false);                
                if(!_.isEmpty(err)){      
                    setErrorText(err.error);                
                }
            }).finally(() => {
                setLoadingState(false);
            });
    }

    const getRI_UserListTable = (userList) => {   
        
        let arrayResult = [];                          
        arrayResult = userList.map((user) => {  
            const objData = {  
                userId: user.userId,    
                name: user.fullName,
                emailAddr: user.emailAddr,  
                dateAdded: user.dateAdded,      
                lastAccess: user.lastAccess || '',
                userManager: user.usrmgr === 'Y',
                billing: user.accountingacc === 'Y',
                claim: user.clmacc === 'Y',
                marketing: user.marketingacc === 'Y',
                firstName: user.firstName,
                lastName: user.lastName,
                authorizationCode: user.authorizationCode,
                producerNo: user.producerNo.toString(),
                insuredName: user.insuredName
            };                                                  
            return objData;                                     
        });                                                       
        return arrayResult;
    };    

    const getCheckBox = (item, index, property) => {
        
        const fieldValue = item[property.id];
        const args = {value:fieldValue}
		return (
			<CheckboxField 
				id="checkbox-field"
                label=''        
                readOnly='true'
                {...args}   
			/>
		);
	};

    const getDate = (item, index, property) => {
        const fieldValue = item[property.id];
        let date = "";
        if(fieldValue){
            const dateFormat = require('dateformat');
            date = dateFormat(new Date(fieldValue), "mmm d, yyyy, hh:mm TT");
        }
        return date;
    };

    const getActionButton = useCallback((item, index,  property ) => {

        return (
            <React.Fragment>
                
                <IconButton
                    icon="mi-edit"       
                    onClick={() => {
                        gotoEditUser(item);
                    }}                                       
                />
                
                <IconButton
                    icon="mi-delete"     
                    onClick={() => {
                        const confirm = confirmDelete({
                            title: 'Delete the User',
                            message: `You are about to delete this user "${item.userId}"!`,
                            status: 'warning',
                            icon: 'mi-error-outline'
                        }, item);                        
                    }}                           
                />                   
            </React.Fragment>

        );
    });

    const deleteUser = (user) => {
        deleteInsuredUser(user.userId);   
        setUser(user);        
        setTimeout(getUserList(), 1000);
        goBack(); 
    };

    const deleteInsuredUser = (userId) => {
        setLoadingState(true);

        UserService.deleteInsuredUser(userId, authHeader)
        .then((data) =>{            
            setMessage(USER_DELETED);   
            setLoadingState(false);             
        })
        .catch((err) => {        
            if(!_.isEmpty(err)){      
                setErrorText(err.error);                
            }
        }).finally(() => {
            setLoadingState(false);
        });
    };

    const confirmDelete = (alertMessage, item) => {
        
        return ModalNextProvider.showConfirm(alertMessage).then((results) => {
            
            if (results === CANCEL) {
                return _.noop();
            }else if (results === CONFIRM) {                
                deleteUser(item);                   
            }
            
        }, _.noop);
    };

    const handleFilterValueChange = useCallback((value) => {    
        
        setSearchKeyword(value);
        
        let filteredUserList = riUserFullList.filter((user) =>{
            return user.userId.toLowerCase().includes(value.toLowerCase()) ||
                user.firstName.toLowerCase().includes(value.toLowerCase()) ||
                user.lastName.toLowerCase().includes(value.toLowerCase());
        });
        setRIUserList(filteredUserList);
    });

    const overrideProps = {
        formLoader: {
            loaded: !isLoading
        },  
        documentsTitleId: {
            visible: !isLoading,
        },
        riUsersTable: {          
            visible: !isLoading,  
            data: riUserList
        },
        searchFilter: {
            value: searchKeyword
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCheckBox,
            getDate,
            handleFilterValueChange,
            gotoAddNewUser,
            gotoEditUser,
            getActionButton,
            confirmDelete
        }
    };
	
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

export default withIntl(RIUserList);


